import { create } from "apisauce";

const kakap_api = create({
  baseURL: "https://dapi.kakao.com",
  headers: { Authorization: "KakaoAK c7c0089c9ea0863e77b86d9065c17234" },
  timeout: 30000,
});

export default kakap_api;
